import useTipsView from '@gp/hooks/useTipsView';

import type { IRecord } from '@gp/types/global';

export interface IFirstTimeChangeHistoriesData {
  project: IRecord<any> | null;
  field: string;
  // 是否强制展示气泡提示
  forceVisibleTips: boolean;
  // 关闭强制展示的气泡提示的回调
  onCloseForceVisibleTips: () => void;
}

/**
 * 查找projects集合中第一个有时间变更记录的project，并返回相关信息
 * @param projects projects集合
 * @returns.project projects集合中第一个有时间变更记录的project（launch_history不为空 或 next_checkpoint_history不为空的project）
 * @returns.field 变更记录字段（区分是launch_history 还是 next_checkpoint_history）
 */
const calcFirstProjectWithTimeChangeHistories = (
  projects?: IRecord<any>[],
): { project: IRecord<any> | null; field: string } => {
  if (!Array.isArray(projects) || !projects.length) return { project: null, field: '' };
  let data = null;
  let field: 'launch_history' | 'next_checkpoint_history' | '' = '';

  for (const project of projects) {
    const { launch_history: launchHistories, next_checkpoint_history: nextMilestoneHistories } = project || {};
    if (Array.isArray(launchHistories) && launchHistories.length > 0) {
      data = project;
      field = 'launch_history';
      break;
    }

    if (Array.isArray(nextMilestoneHistories) && nextMilestoneHistories.length > 0) {
      data = project;
      field = 'next_checkpoint_history';
      break;
    }
  }

  return { project: data, field };
};

export default function useFirstTimeChangeHistoriesEffect(projects?: IRecord<any>[]): IFirstTimeChangeHistoriesData {
  const { project, field } = calcFirstProjectWithTimeChangeHistories(projects);

  const { isTipsView, handleViewedTips } = useTipsView('pipeline-projectlist-time-change-history-view');

  return {
    project,
    field,
    forceVisibleTips: !isTipsView,
    onCloseForceVisibleTips: handleViewedTips,
  };
}
